import { render, staticRenderFns } from "./PageDisable.vue?vue&type=template&id=61ab0c50&scoped=true&"
import script from "./PageDisable.vue?vue&type=script&lang=js&"
export * from "./PageDisable.vue?vue&type=script&lang=js&"
import style0 from "./PageDisable.vue?vue&type=style&index=0&id=61ab0c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab0c50",
  null
  
)

export default component.exports